import { createSlice } from '@reduxjs/toolkit'

export const missedCallSlice = createSlice({
    name: 'missedCall',
    initialState: {
        missedCall: 0
    },
    reducers: {
        setMissedCall(state, action) {
            const val = Number(action.payload)

            if(!isNaN(val)){
                if(val != 0){
                    state.missedCall += val
                }else{
                    state.missedCall = 0
                }
            }
        },
    },
})

export const { setMissedCall } = missedCallSlice.actions;

export default missedCallSlice.reducer

